import { DEFAULT_MY_ACCOUNT_PATH } from 'account-management-data';
import { LegacyFeatureRoutesConfig } from './LegacyFeatureRoutesConfig';

export const defaultLegacyFeatureRoutesConfig: LegacyFeatureRoutesConfig = {
  profilePath: DEFAULT_MY_ACCOUNT_PATH,
};
